export default __webpack_public_path__ + "static/media/search.d1f08335.svg";